/* global wp, pwsL10n */

import $ from 'jquery';

function handlePasswordUpdate( pwdStrength ) {
  const $strengthStatus = $( '.form-password-strength' );
  const $confirmStatus = $( '.form-password-confirm-status' );
  $strengthStatus.parent().removeClass();
  $confirmStatus.parent().removeClass();
  $strengthStatus.css( 'display', 'block' );
  $confirmStatus.css( 'display', 'none' );

  switch ( pwdStrength ) {
    case 2:
      $strengthStatus.html( pwsL10n.bad ).parent().addClass( 'form-pw-bad' );
      break;

    case 3:
      $strengthStatus.html( pwsL10n.good ).parent().addClass( 'form-pw-good' );
      break;

    case 4:
      $strengthStatus.html( pwsL10n.strong ).parent().addClass( 'form-pw-strong' );
      break;

    case 5:
      $confirmStatus.html( pwsL10n.mismatch ).parent().addClass( 'form-pw-mismatch' );
      $confirmStatus.css( 'display', 'block' );
      break;

    default:
      $strengthStatus.html( pwsL10n.short ).parent().addClass( 'form-pw-short' );
  }

  $( '.submit' ).attr( 'disabled', 'disabled' );

  if ( pwdStrength === 4 ) {
    $( '.submit' ).removeAttr( 'disabled' );
  }
}

function init() {
  $( 'body' ).on( 'keyup', '.form-set-password, .form-confirm-password', () => {
    const blacklistedWords = wp.passwordStrength.userInputDisallowedList();
    const pwd = $( '.form-set-password' ).val();
    const pwdConfirm = $( '.form-confirm-password' ).val();
    const pwdStrength = wp.passwordStrength.meter( pwd, blacklistedWords, pwdConfirm );

    handlePasswordUpdate( pwdStrength );
  } );
}

export default {
  init,
};
